import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";

import textTransformationGif from "src/shared/assets/gifSections/textTransformation.gif";
import textTransformationImage from "src/shared/assets/textTransformation.png";

export const TextTransformation: React.FC = () => {
  return (
    <Stack width={1} direction="column" gap={1}>
      <Stack
        width={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography
          color="primary.contrastText"
          variant="h6"
          fontWeight={300}
          textTransform="uppercase"
          sx={{
            fontSize: {
              sm: "1.25rem",
              xs: "1rem",
            },
          }}
        >
          How it works
        </Typography>

        <Typography
          variant="h4"
          color="text.secondary"
          fontWeight={300}
          sx={{
            fontSize: {
              xs: "1.675rem",
              sm: "2.125rem",
            },
          }}
        >
          Text{" "}
          <Typography
            component="span"
            variant="inherit"
            color="primary"
            fontWeight="inherit"
          >
            Transformation
          </Typography>{" "}
          Journey
        </Typography>

        <Typography
          maxWidth={0.55}
          color="text.primary"
          variant="body1"
          textAlign="center"
          sx={{
            fontSize: {
              sm: "1rem",
              xs: "0.875rem",
            },
          }}
        >
          “Write Better” is the AI-powered writing assistant that helps you
          communicate more effectively and efficiently. Improve grammar,
          clarity, and style with a single click.
        </Typography>
      </Stack>

      <Stack
        width={1}
        marginTop={6}
        direction="row"
        alignItems="center"
        gap={4}
        sx={{
          flexDirection: {
            md: "row",
            xs: "column-reverse",
          },
        }}
      >
        <Box
          width={1}
          border={1}
          borderRadius={4}
          borderColor="text.primary"
          component="img"
          src={textTransformationGif}
          alt="textTransformationGif"
          sx={{
            objectFit: "contain",
            overflow: "hidden",
          }}
        />

        <Divider
          orientation="vertical"
          flexItem
          sx={{
            borderColor: "text.primary",
            flexDirection: {
              md: "flex",
              xs: "none",
            },
          }}
        />

        <Box
          width={1}
          component="img"
          src={textTransformationImage}
          alt="textTransformationImage"
          sx={{
            objectFit: "contain",
            overflow: "hidden",
          }}
        />
      </Stack>
    </Stack>
  );
};
